import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const deployProxmoxUser = (
  userId: number,
  realm: string,
  language: string,
  options: { expire?: number; groups?: string; enabled?: boolean; comment?: string },
  setLoading: Function,
  onSuccess: Function
) => {
  setLoading(true);
  ApiService.post("proxmox/users", {
    user_id: userId,
    realm,
    ...options,
  })
    .then(() => onSuccess())
    .catch((error) => {
      console.error("Proxmox deploy error:", error);
      const message = error?.data?.error?.message;
      if (message?.includes("already exists")) {
        alert(translate(language, "PAGES.USER.USER_BLOCK.PROXMOX.ALREADY_EXISTS"));
      } else if (message) {
        alert(message);
      } else {
        alert(translate(language, "ERROR.API_ERROR"));
      }
    })
    .finally(() => setLoading(false));
};
